"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var descendingComparator = function descendingComparator(a, b) {
  return b - a;
};

var _default = descendingComparator;
exports["default"] = _default;